import { MantineStyleProps } from '@mantine/core';
import { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import {
  BaseFinancialItem,
  SpendingAccount,
} from 'src/financial/financial-data/hooks/useFinancialItems';
import {
  FinancialItemGenericTable,
  formatDate,
  getFinancialItemType,
} from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { formatMoney } from 'src/common/currency';
import { useCurrency } from 'src/common/hooks/useCurrency';

type SpendingAccountsTableTableProps = {
  financialItems: SpendingAccount[];
  metadata: DynamicUiEntitiesMetadata;
  pl?: MantineStyleProps['pl'];
  pr?: MantineStyleProps['pr'];
  titleParts?: string[];
  onSubmit: () => void;
  onRowClick: (clickedItem: BaseFinancialItem) => void;
};
export default function SpendingAccountsTable({
  financialItems,
  metadata,
  pl = 50,
  onRowClick,
}: SpendingAccountsTableTableProps) {
  const currency = useCurrency();
  const fieldsRenderingRules = [
    {
      headerTitle: 'Description',
      sortable: true,
      sortKey: 'description',
      render: (item: SpendingAccount) =>
        item.description?.length && item.description.length > 50
          ? item.description.slice(0, 50) + '...'
          : item.description,
    },
    {
      headerTitle: 'Provider',
      sortable: true,
      sortKey: 'provider',
      render: (item: SpendingAccount) => item.provider,
    },
    {
      headerTitle: 'Type',
      sortable: true,
      sortKey: 'type',
      render: (item: SpendingAccount) => getFinancialItemType(item, metadata),
    },
    {
      headerTitle: 'Balance date',
      sortable: true,
      sortKey: 'balanceDate',
      render: (item: SpendingAccount) => formatDate(item.balanceDate),
    },
    {
      headerTitle: 'Balance',
      sortable: true,
      sortKey: 'currentBalance',
      render: (item: SpendingAccount) =>
        item.currentBalance != null ? formatMoney(item.currentBalance, currency) : undefined,
    },
  ];

  return (
    <>
      <FinancialItemGenericTable
        financialItems={financialItems}
        fieldsRenderingRules={fieldsRenderingRules}
        pl={pl}
        onRowClick={onRowClick}
      />
    </>
  );
}
